import {SEND_COMMAND_ERROR} from "../../reducers/cleaningControlReducer";

export const sendCommandError = (namespace, error) =>{
    return {
        type: namespace + SEND_COMMAND_ERROR,
        payload: {error}
    }
}